import script from "./PersonalInfoStep2Content.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalInfoStep2Content.vue?vue&type=script&setup=true&lang=js"

import "./PersonalInfoStep2Content.vue?vue&type=style&index=0&id=e64a49ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e64a49ca"]])

export default __exports__